// packages/shared-hooks/src/clients/useArchiveClientLegalEntity.ts
//
// `POST /clients/:id/legal-entities/:legalEntityId/archive` — soft-delete
// one legal entity. Unlike contacts, legal entities have no must-have-one
// invariant — a client may legitimately operate with zero active OOO/IP
// rows.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClientLegalEntitySchema, type ClientLegalEntity } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function useArchiveClientLegalEntity(clientId: string, legalEntityId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<ClientLegalEntity, unknown, void>({
    mutationFn: () =>
      client.post<ClientLegalEntity>(
        `/clients/${clientId}/legal-entities/${legalEntityId}/archive`,
        undefined,
        {},
        ClientLegalEntitySchema,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: clientsKeys.detail(clientId) });
      void qc.invalidateQueries({ queryKey: clientsKeys.all });
    },
  });
}
